import { render, staticRenderFns } from "./CommonPostCounseling.vue?vue&type=template&id=2f80ad29&lang=pug&"
import script from "./CommonPostCounseling.vue?vue&type=script&lang=ts&"
export * from "./CommonPostCounseling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports